export default __webpack_public_path__ + "static/media/1.98964eb1.jpg";